module.exports = __webpack_public_path__ + "img/ve.ded42505.png";